import { HttpResponse, HttpStatusCode } from '@angular/common/http';
import { ApiEnvelope, unwrapEnvelope } from '@/app/core/http/api-envelope.model';
import { filenameFromContentDisposition } from '@/app/shared/utils/content-disposition.util';
import {
  RegistryDownloadFormat,
  RegistryDownloadJob,
  RegistryDownloadResult,
} from '../models/beneficiary-registry.model';

const DEFAULT_FILE_BASE_NAME = 'padron-beneficiarios';
const DOWNLOAD_MODE_HEADER = 'X-Descarga-Modo';
const ASYNC_DOWNLOAD_MODE = 'ASINCRONO';
const JSON_CONTENT_TYPE = 'application/json';
const FALLBACK_CONTENT_TYPES: Record<RegistryDownloadFormat, string> = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  csv: 'text/csv',
};

export function isRegistryDownloadJobResponse(response: HttpResponse<Blob>): boolean {
  return (
    response.status === HttpStatusCode.Accepted ||
    response.headers.get(DOWNLOAD_MODE_HEADER)?.toUpperCase() === ASYNC_DOWNLOAD_MODE ||
    (response.headers.get('Content-Type')?.toLowerCase().startsWith(JSON_CONTENT_TYPE) ?? false)
  );
}

export function toRegistryDownloadFile(
  response: HttpResponse<Blob>,
  format: RegistryDownloadFormat,
): RegistryDownloadResult {
  const blob = response.body;
  if (!blob) {
    throw new Error('La descarga del padrón no incluye cuerpo.');
  }

  return {
    mode: 'sync',
    file: {
      blob,
      fileName:
        filenameFromContentDisposition(response.headers.get('Content-Disposition')) ??
        `${DEFAULT_FILE_BASE_NAME}.${format}`,
      contentType: response.headers.get('Content-Type') ?? FALLBACK_CONTENT_TYPES[format],
    },
  };
}

export async function toRegistryDownloadJob(
  response: HttpResponse<Blob>,
  path: string,
): Promise<RegistryDownloadResult> {
  const text = (await response.body?.text()) ?? '{}';
  const job = unwrapEnvelope(JSON.parse(text) as ApiEnvelope<RegistryDownloadJob>, path);
  return { mode: 'async', job };
}
